import qrcode from "qrcode-generator";

export const createQRCode = (text : string, typeNumber : any, errorCorrectionLevel : any, mode : any) => {
  try {
    const qr = qrcode(typeNumber, errorCorrectionLevel || 'M');
    qr.addData(text, mode);
    qr.make();

    const opts = {
      cellSize : 5,
      margin: 5,
      scalable: false
    }
    return qr.createSvgTag(opts);
  } catch (error) {
    return "";
  }
}
